import React from 'react';

const Plus: React.FC = () => {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14 8.48658H7.98658V14.5H6.01342V8.48658H0V6.51342H6.01342V0.5H7.98658V6.51342H14V8.48658Z"
        fill="#4B5563"
      />
    </svg>
  );
};

export default Plus;
